import PropTypes from "prop-types";

const ErrorMessages = ({ isErrors }) => (
  <ul style={{ color: "red", marginTop: 30 }}>
    {isErrors.map((error, index) => (
      <li key={index}>
        {`ParallelNumber - ${error["ParallelNumber"]} - ${error["Error"]}`}
      </li>
    ))}
  </ul>
);

ErrorMessages.propTypes = {
  isErrors: PropTypes.array.isRequired,
};

export default ErrorMessages;
